import { FolderKanban } from 'lucide-react'
import SectionTabs from '../../components/common/SectionTabs.jsx'
import { hasModule } from '../access/modules.js'
import { useCurrentUser } from '../../hooks/useCurrentUser.js'
import { CONTRACT_SECTIONS } from './sections.js'

/** Onglets de « Offre et contrats » : projets et livrables (Serge), puis devis, contrats, factures. */
export default function OfferTabs({ activeKey }) {
  const { user } = useCurrentUser()
  const tabs = [
    { key: 'offre', label: 'Projets et livrables', icon: FolderKanban, to: '/dashboard/serge-projects' },
    ...(hasModule(user, 'prospects') ? CONTRACT_SECTIONS.map((s) => ({ ...s, to: `/dashboard/contrats/${s.key}` })) : []),
  ]

  return <SectionTabs label="Offre et contrats" activeKey={activeKey} tabs={tabs} />
}
